import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "value-with-label" }
const _hoisted_2 = { key: 0 }

import { computed } from 'vue'

import {
  formatBoolean,
  formatDate,
  formatGender,
  formatValue,
} from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'ValueWithLabel',
  props: {
  value: {
    type: [Boolean, Date, String],
    default: null,
  },

  type: {
    type: String,
    default: 'string',
    validate: (value: string): boolean =>
      ['boolean', 'date', 'email', 'gender', 'string'].includes(value),
  },

  label: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const formattedValue = computed<string>((): string => {
  switch (props.type) {
    case 'boolean':
      return formatBoolean(props.value as boolean)
    case 'date':
      return formatDate(props.value as Date)
    case 'email':
      return formatValue((props.value as string)?.toLowerCase())
    case 'gender':
      return formatGender(props.value as string)
    case 'string':
    default:
      return formatValue(props.value as string)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("small", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.label), 1),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, ":", -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("strong", null, _toDisplayString(formattedValue.value), 1)
  ]))
}
}

})